import React from 'react';
import { Box, Skeleton, Divider } from '@mui/material';

interface SideNavSkeletonProps {
  width?: number;
}

const SideNavSkeleton: React.FC<SideNavSkeletonProps> = ({ width = 256 }) => {
  return (
    <Box
      component='nav'
      sx={{
        width: width,
        backgroundColor: '#FFFFFF',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: 64,
          px: 3,
          borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
        }}
      >
        <Skeleton variant="rectangular" width={90} height={30} />
      </Box>

      <Box
        sx={{
          flexGrow: 1,
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box sx={{ py: 0 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              py: 1.5,
              pl: 2,
              pr: 4,
            }}
          >
            <Skeleton variant="circular" width={24} height={24} sx={{ mr: 1.5 }} />
            <Skeleton variant="text" width={80} height={24} />
          </Box>
        </Box>

        <Divider sx={{ my: 1, mx: 2 }} />

        <Box sx={{ py: 0 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              py: 1.5,
              pl: 2,
              pr: 4,
            }}
          >
            <Skeleton variant="circular" width={24} height={24} sx={{ mr: 1.5 }} />
            <Skeleton variant="text" width={120} height={24} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default SideNavSkeleton;